module.exports = __webpack_public_path__ + "img/interpeople1_20250207_50_40.70552aec.jpg";